module.exports = __webpack_public_path__ + "static/media/btn_arrow_right.531a1ddd.svg";